var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08817 7.84082C3.08817 5.21681 5.21535 3.08964 7.83936 3.08964C10.4634 3.08964 12.5905 5.21681 12.5905 7.84082C12.5905 8.8291 12.2888 9.74691 11.7724 10.5071L10.1735 9.10769C9.85934 8.8327 9.38173 8.86447 9.10674 9.17865C8.83174 9.49283 8.86351 9.97044 9.17769 10.2454L10.7347 11.6082C9.93309 12.2251 8.92907 12.592 7.83936 12.592C5.21535 12.592 3.08817 10.4648 3.08817 7.84082ZM11.8892 12.6187C10.7972 13.5452 9.38355 14.104 7.83936 14.104C4.38029 14.104 1.57617 11.2999 1.57617 7.84082C1.57617 4.38176 4.38029 1.57764 7.83936 1.57764C11.2984 1.57764 14.1025 4.38176 14.1025 7.84082C14.1025 9.21066 13.6628 10.4778 12.9167 11.5087L13.5992 12.1061C13.9134 12.381 13.9451 12.8587 13.6702 13.1728C13.3952 13.487 12.9175 13.5188 12.6034 13.2438L11.8892 12.6187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQa);
export default __webpack_public_path__ + "static/media/ic_qa.6b98281d23660b2abaea448953f7b371.svg";
export { ForwardRef as ReactComponent };